import { isValidNameLength, isNotEmpty, MAX_LENGTH_NAME } from "@/utils/string";
import { FORM_VALIDATORS, isMail, isColor, isName } from "@/utils/fieldValidations";
export default {
    methods: {
        /**
         * Validator with all validator types
         * Validators return a message in case we have an error or true if no errors
         * @param value
         * @param required
         * @param validator
         * @returns {boolean|string}
         */
        validInput(value, { validator, maxLength } = {}) {
            if (!isNotEmpty(value)) return this.$trad.formErrorMessages.emptyField;
            if (maxLength !== 0 && !isValidNameLength(value, maxLength)) return this.$trad.formErrorMessages.fieldTooLong;

            switch (validator) {
                case FORM_VALIDATORS.mail:
                    return isMail(value) ? true : this.$trad.formErrorMessages.mailInvalid;
                case FORM_VALIDATORS.color:
                    return isColor(value) ? true : this.$trad.formErrorMessages.color;
                default:
                    return true;
            }
        }
    }
};



// WEBPACK FOOTER //
// ./src/mixins/FormValidator.js